import axios from "axios";

let api = axios.create({
    baseURL: process.env.REACT_APP_SED_API_URL
});

api.interceptors.request.use((config)=>{
    const accesstoken = localStorage.getItem("_ssat");
    if(accesstoken) config.headers.Authorization='Bearer '+accesstoken;
    return config;
})

export default api;